import React, { Component } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, AppBar, Typography, Box, IconButton } from '@mui/material';
import { useSlideInContext } from "./SlideInProvider";
const noop = () => { };

const SlideIn = (props: any) => {
    const { open, disableClose, toggleDrawer, content, slideInProps } = useSlideInContext();
    const handleOnClose = disableClose ? noop : toggleDrawer;
    const Component = content?.content;
    return (
        <div>
            <Drawer
                anchor="right"
                open={open}
                onClose={handleOnClose}
            >
                <Box component="div" sx={{ position: 'relative', width: "450px" }} >
                    <AppBar position="fixed" color="secondary" sx={{ width: "450px", height: "65px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Typography variant="h6" noWrap component="div">
                            {content?.header}
                        </Typography>
                    </AppBar>

                    <IconButton disabled={disableClose} onClick={handleOnClose} sx={{ position: "absolute", top: "10px", right: "10px", zIndex: "9999", color: "#fff" }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box component="div" sx={{
                    height: "calc(100dvh - 65px)", width: "450px",
                    //   backgroundColor: "#2D2E35",
                    marginTop: "auto", padding: "24px"
                }}>
                    <>
                        {Component && <Component {...slideInProps} />}
                        {/* {content?.content(slideInProps)} */}
                    </>
                </Box>
            </Drawer>
        </div>
    );
}

export { SlideIn };